import React from "react";

import styled from "styled-components";
import { SV } from "../../styles/styles-variables";
import { DashboardBox } from "./dashboard-box";

export const HomeIcon: React.FunctionComponent<any> = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.2 3.15C10.4889 2.61667 9.51111 2.61667 8.8 3.15L2.8 7.65C2.29639 8.02771 2 8.62049 2 9.25V16C2 17.1046 2.89543 18 4 18H16.1875C17.1885 18 18 17.1885 18 16.1875V9.25C18 8.62049 17.7036 8.02771 17.2 7.65L11.2 3.15ZM7.6 1.55C9.02222 0.483333 10.9778 0.483333 12.4 1.55L18.4 6.05C19.4072 6.80542 20 7.99097 20 9.25V16.1875C20 18.2931 18.2931 20 16.1875 20H4C1.79086 20 0 18.2091 0 16V9.25C0 7.99097 0.592777 6.80542 1.6 6.05L7.6 1.55Z"
      fill={SV.colors.interactive1}
    />
  </svg>
);

export const ThumbsDownIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="2em"
    viewBox="0 0 512 512"
    fill="none"
    style={{ padding: "0 0.5em" }}
  >
    <path
      fill={SV.colors.interactive1}
      d="M323.8 477.2c-38.2 10.9-78.1-11.2-89-49.4l-5.7-20c-3.7-13-10.4-25-19.5-35l-51.3-56.4c-8.9-9.8-8.2-25 1.6-33.9s25-8.2 33.9 1.6l51.3 56.4c14.1 15.5 24.4 34 30.1 54.1l5.7 20c3.6 12.7 16.9 20.1 29.7 16.5s20.1-16.9 16.5-29.7l-5.7-20c-5.7-19.9-14.7-38.7-26.6-55.5c-5.2-7.3-5.8-16.9-1.7-24.9s12.3-13 21.3-13L448 288c8.8 0 16-7.2 16-16c0-6.8-4.3-12.7-10.4-15c-7.4-2.8-13-9-14.9-16.7s.1-15.8 5.3-21.7c2.5-2.8 4-6.5 4-10.6c0-7.8-5.6-14.3-13-15.7c-8.2-1.6-15.1-7.3-18-15.2s-1.6-16.7 3.6-23.3c2.1-2.7 3.4-6.1 3.4-9.9c0-6.7-4.2-12.6-10.2-14.9c-11.5-4.5-17.7-16.9-14.4-28.8c.4-1.3 .6-2.8 .6-4.3c0-8.8-7.2-16-16-16H286.5c-12.6 0-25 3.7-35.5 10.7l-61.7 41.1c-11 7.4-25.9 4.4-33.3-6.7s-4.4-25.9 6.7-33.3l61.7-41.1c18.4-12.3 40-18.8 62.1-18.8H384c34.7 0 62.9 27.6 64 62c14.6 11.7 24 29.7 24 50c0 4.5-.5 8.8-1.3 13c15.4 11.7 25.3 30.2 25.3 51c0 6.5-1 12.8-2.8 18.7C504.8 238.3 512 254.3 512 272c0 35.3-28.6 64-64 64l-92.3 0c4.7 10.4 8.7 21.2 11.8 32.2l5.7 20c10.9 38.2-11.2 78.1-49.4 89zM32 384c-17.7 0-32-14.3-32-32V128c0-17.7 14.3-32 32-32H96c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H32z"
    />
  </svg>
);

export const InfoIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    // height="1em"
    viewBox="0 0 512 512"
    width="24"
    height="24"
    // style={{paddingLeft:10}}
  >
    {/* <!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --> */}
    <path
      fill={SV.colors.interactive1}
      d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216 336h24V272H216c-13.3 0-24-10.7-24-24s10.7-24 24-24h48c13.3 0 24 10.7 24 24v88h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H216c-13.3 0-24-10.7-24-24s10.7-24 24-24zm40-208a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    />
  </svg>
);

export const RevisionIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 4C0 1.79086 1.79086 0 4 0H16C18.2091 0 20 1.79086 20 4V16C20 18.2091 18.2091 20 16 20H4C1.79086 20 0 18.2091 0 16V4ZM4 2C2.89543 2 2 2.89543 2 4V16C2 17.1046 2.89543 18 4 18H16C17.1046 18 18 17.1046 18 16V4C18 2.89543 17.1046 2 16 2H4Z"
      fill={SV.colors.interactive1}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.1562 6.2455C15.573 6.6079 15.617 7.23953 15.2546 7.65628L10.0372 13.6563C9.67991 14.0671 9.05963 14.1167 8.64169 13.7677L4.85915 10.6098C4.43519 10.2559 4.37843 9.62529 4.73238 9.20133C5.08633 8.77737 5.71694 8.72061 6.1409 9.07456L9.17108 11.6043L13.7454 6.34392C14.1078 5.92716 14.7395 5.8831 15.1562 6.2455Z"
      fill={SV.colors.interactive1}
    />
  </svg>
);

export const ExamsIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3 0C1.34315 0 0 1.34315 0 3V17C0 18.6569 1.34315 20 3 20H17C18.6569 20 20 18.6569 20 17V3C20 1.34315 18.6569 0 17 0H3ZM2 3C2 2.44772 2.44772 2 3 2H17C17.5523 2 18 2.44772 18 3V17C18 17.5523 17.5523 18 17 18H3C2.44772 18 2 17.5523 2 17V3Z"
      fill={SV.colors.interactive1}
    />
    <path d="M5 6H15V8H5V6Z" fill={SV.colors.interactive1} />
    <path d="M5 9.5H12V11.5H5V9.5Z" fill={SV.colors.interactive1} />
    <path d="M5 13H10V15H5V13Z" fill={SV.colors.interactive1} />
    <path
      d="M14.5 12C13.1193 12 12 13.1193 12 14.5C12 15.8807 13.1193 17 14.5 17C15.8807 17 17 15.8807 17 14.5C17 13.1193 15.8807 12 14.5 12ZM14.5 13.5V14.2H15.2V15.7H14.5V15H13.8V13.5H14.5Z"
      fill={SV.colors.interactive1}
    />
  </svg>
);

export const StudyGuideIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3 2C2.44772 2 2 2.44772 2 3V16C2 16.5523 2.44772 17 3 17H8C8.55228 17 9 17.4477 9 18C9 18.5523 8.55228 19 8 19H3C1.34315 19 0 17.6569 0 16V3C0 1.34315 1.34315 0 3 0H8C9.10457 0 10 0.895431 10 2V17C10 17.5523 9.55228 18 9 18C8.44772 18 8 17.5523 8 17V2H3ZM12 2C12 0.895431 12.8954 0 14 0H17C18.6569 0 20 1.34315 20 3V16C20 17.6569 18.6569 19 17 19H14C13.4477 19 13 18.5523 13 18C13 17.4477 13.4477 17 14 17H17C17.5523 17 18 16.5523 18 16V3C18 2.44772 17.5523 2 17 2H14V17C14 17.5523 13.5523 18 13 18C12.4477 18 12 17.5523 12 17V2ZM4 5C4 4.44772 4.44772 4 5 4H7C7.55228 4 8 4.44772 8 5C8 5.55228 7.55228 6 7 6H5C4.44772 6 4 5.55228 4 5ZM4 9C4 8.44772 4.44772 8 5 8H7C7.55228 8 8 8.44772 8 9C8 9.55228 7.55228 10 7 10H5C4.44772 10 4 9.55228 4 9Z"
      fill={SV.colors.interactive1}
    />
  </svg>
);

export const ResultsIcon = () => (
  <svg
    width="20"
    height="17"
    viewBox="0 0 20 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4 0C1.79086 0 0 1.79086 0 4V13C0 15.2091 1.79086 17 4 17H7C8.19469 17 9.26706 16.4762 10 15.6458C10.7329 16.4762 11.8053 17 13 17H16C18.2091 17 20 15.2091 20 13V8.5C20 6.29086 18.2091 4.5 16 4.5H13C12.2714 4.5 11.5883 4.69479 11 5.03513V4C11 1.79086 9.20914 0 7 0H4ZM11 8.5V13C11 14.1046 11.8954 15 13 15H16C17.1046 15 18 14.1046 18 13V8.5C18 7.39543 17.1046 6.5 16 6.5H13C11.8954 6.5 11 7.39543 11 8.5ZM9 8.5V4C9 2.89543 8.10457 2 7 2H4C2.89543 2 2 2.89543 2 4V13C2 14.1046 2.89543 15 4 15H7C8.10457 15 9 14.1046 9 13V8.5Z"
      fill={SV.colors.interactive1}
    />
  </svg>
);

export const SettingsIcon: React.FunctionComponent<any> = ({ onClick }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ cursor: "pointer" }}
    onClick={onClick}
  >
    <path
      d="M17.6852 11.7274L18.5434 11.2141L18.5433 11.2139L17.6852 11.7274ZM18.5694 7.32507L19.1757 8.12036L19.1757 8.12035L18.5694 7.32507ZM18.5534 12.6967L19.1591 11.901L19.1591 11.901L18.5534 12.6967ZM18.7208 13.4231L19.5789 13.9366L19.5789 13.9366L18.7208 13.4231ZM17.4009 15.6286L16.5428 15.115L16.5428 15.115L17.4009 15.6286ZM16.7159 15.8377L16.3511 16.7688H16.3511L16.7159 15.8377ZM12.2988 17.2911L11.4407 16.7776L11.4403 16.7784L12.2988 17.2911ZM11.8627 18.5003L12.8515 18.6499V18.6499L11.8627 18.5003ZM8.11989 18.5044L9.10825 18.3523L8.11989 18.5044ZM3.2759 15.8255L2.90869 14.8953H2.90868L3.2759 15.8255ZM2.58672 15.6168L1.72866 16.1304H1.72866L2.58672 15.6168ZM1.26689 13.4116L2.12495 12.898H2.12495L1.26689 13.4116ZM1.43203 12.6881L0.824126 11.8941L0.824124 11.8941L1.43203 12.6881ZM2.30961 8.29113L1.45124 8.80416L1.45153 8.80464L2.30961 8.29113ZM1.43513 7.31641L0.83121 8.11346H0.83121L1.43513 7.31641ZM1.26645 6.58921L0.408319 6.07578L0.408319 6.07578L1.26645 6.58921ZM2.58461 4.38607L1.72648 3.87264H1.72648L2.58461 4.38607ZM3.27085 4.17736L2.90408 5.10767H2.90408L3.27085 4.17736ZM7.69544 2.72687L6.83765 2.21287L6.83738 2.21333L7.69544 2.72687ZM8.13387 1.50232L9.12336 1.64689V1.64689L8.13387 1.50232ZM11.8721 1.49834L12.8611 1.3508V1.3508L11.8721 1.49834ZM16.7265 4.18972L16.3569 3.26052L16.3569 3.26052L16.7265 4.18972ZM17.4169 4.39779L18.275 3.88424L18.275 3.88424L17.4169 4.39779ZM18.7355 6.60099L17.8775 7.11454L17.8775 7.11454L18.7355 6.60099ZM18.5433 11.2139C17.9253 10.1813 18.1945 8.86829 19.1757 8.12036L17.9632 6.52979C16.21 7.86622 15.6624 10.2948 16.8271 12.241L18.5433 11.2139ZM19.1591 11.901C18.9156 11.7157 18.7059 11.4857 18.5434 11.2141L16.827 12.2408C17.1249 12.7387 17.5087 13.1583 17.9477 13.4925L19.1591 11.901ZM19.5789 13.9366C20.0307 13.1817 19.7156 12.3247 19.1591 11.901L17.9477 13.4925C17.8798 13.4408 17.828 13.3657 17.8049 13.2717C17.7804 13.172 17.7868 13.0364 17.8628 12.9095L19.5789 13.9366ZM18.2589 16.1421L19.5789 13.9366L17.8628 12.9095L16.5428 15.115L18.2589 16.1421ZM16.3511 16.7688C16.9802 17.0152 17.8297 16.8594 18.2589 16.1421L16.5428 15.115C16.6151 14.9942 16.7245 14.9246 16.8212 14.8965C16.913 14.8698 17.0028 14.8761 17.0806 14.9066L16.3511 16.7688ZM13.1569 17.8046C13.7876 16.7508 15.1564 16.3008 16.3511 16.7688L17.0806 14.9066C15.0275 14.1023 12.601 14.8388 11.4407 16.7776L13.1569 17.8046ZM12.8515 18.6499C12.8949 18.363 12.9945 18.0765 13.1573 17.8039L11.4403 16.7784C11.1436 17.275 10.956 17.8084 10.874 18.3508L12.8515 18.6499ZM11.3244 20C12.1859 20 12.7505 19.3176 12.8515 18.6499L10.874 18.3508C10.8858 18.2724 10.923 18.1948 10.9905 18.1302C11.0621 18.0617 11.1792 18 11.3244 18V20ZM8.65637 20H11.3244V18H8.65637V20ZM7.13153 18.6566C7.23431 19.3244 7.80014 20 8.65637 20V18C8.80075 18 8.91772 18.061 8.9899 18.1297C9.05803 18.1945 9.09602 18.2729 9.10825 18.3523L7.13153 18.6566ZM4.61158 16.5732C5.91209 16.5732 6.95347 17.4997 7.13153 18.6566L9.10825 18.3523C8.77571 16.1918 6.87047 14.5732 4.61158 14.5732V16.5732ZM3.64311 16.7556C3.93964 16.6386 4.26614 16.5732 4.61158 16.5732V14.5732C4.01208 14.5732 3.4366 14.6869 2.90869 14.8953L3.64311 16.7556ZM1.72866 16.1304C2.16047 16.8519 3.01482 17.0037 3.64311 16.7556L2.90868 14.8953C2.98551 14.865 3.07437 14.8584 3.16576 14.8847C3.2621 14.9124 3.37212 14.9819 3.44478 15.1033L1.72866 16.1304ZM0.408833 13.9251L1.72866 16.1304L3.44478 15.1033L2.12495 12.898L0.408833 13.9251ZM0.824124 11.8941C0.268953 12.3192 -0.0407599 13.1739 0.408833 13.9251L2.12495 12.898C2.20057 13.0244 2.20743 13.1596 2.18314 13.2596C2.16017 13.3541 2.10823 13.4298 2.03993 13.4821L0.824124 11.8941ZM1.45153 8.80464C2.06847 9.83554 1.80085 11.1463 0.824126 11.8941L2.03993 13.4821C3.78661 12.1449 4.33024 9.72021 3.16769 7.77761L1.45153 8.80464ZM0.83121 8.11346C1.07635 8.29921 1.28765 8.53045 1.45124 8.80416L3.16798 7.77809C2.8683 7.2767 2.48165 6.85473 2.03905 6.51937L0.83121 8.11346ZM0.408319 6.07578C-0.0442953 6.83227 0.273006 7.69051 0.83121 8.11346L2.03905 6.51937C2.10709 6.57092 2.15908 6.64593 2.18232 6.73996C2.20695 6.83965 2.20065 6.97549 2.12459 7.10263L0.408319 6.07578ZM1.72648 3.87264L0.408319 6.07578L2.12459 7.10263L3.44274 4.89949L1.72648 3.87264ZM3.63763 3.24705C3.00806 2.99884 2.15648 3.15394 1.72648 3.87264L3.44274 4.89949C3.37032 5.02054 3.26062 5.09019 3.16386 5.11823C3.07191 5.14487 2.98202 5.1384 2.90408 5.10767L3.63763 3.24705ZM6.83738 2.21333C6.20556 3.26902 4.83355 3.71854 3.63763 3.24705L2.90408 5.10767C4.95923 5.91791 7.39128 5.18235 8.55351 3.24042L6.83738 2.21333ZM7.14438 1.35774C7.10185 1.6488 7.00204 1.93854 6.83765 2.21287L8.55323 3.24088C8.8551 2.73711 9.04316 2.19579 9.12336 1.64689L7.14438 1.35774ZM8.6723 0C7.80772 0 7.24239 0.686888 7.14438 1.35774L9.12336 1.64689C9.11183 1.72583 9.07466 1.80399 9.00713 1.86893C8.93542 1.93789 8.81799 2 8.6723 2V0ZM11.3352 0H8.6723V2H11.3352V0ZM12.8611 1.3508C12.7611 0.680263 12.1948 0 11.3352 0V2C11.1903 2 11.0731 1.93855 11.0009 1.86955C10.9328 1.80444 10.8949 1.72568 10.883 1.64587L12.8611 1.3508ZM15.3832 3.44531C14.0783 3.44531 13.0345 2.51318 12.8611 1.3508L10.883 1.64587C11.2069 3.81699 13.1173 5.44531 15.3832 5.44531V3.44531ZM16.3569 3.26052C16.0588 3.37909 15.7305 3.44531 15.3832 3.44531V5.44531C15.9868 5.44531 16.5657 5.32985 17.096 5.11892L16.3569 3.26052ZM18.275 3.88424C17.8423 3.16136 16.9858 3.01038 16.3569 3.26052L17.096 5.11892C17.0191 5.14953 16.93 5.15633 16.8385 5.13009C16.7419 5.10242 16.6317 5.03298 16.5589 4.91134L18.275 3.88424ZM19.5936 6.08744L18.275 3.88424L16.5589 4.91134L17.8775 7.11454L19.5936 6.08744ZM19.1757 8.12035C19.7326 7.69578 20.0438 6.83976 19.5936 6.08744L17.8775 7.11454C17.8017 6.98802 17.795 6.85261 17.8194 6.75251C17.8425 6.65793 17.8946 6.58207 17.9632 6.52979L19.1757 8.12035ZM12 10C12 11.1046 11.1046 12 10 12V14C12.2091 14 14 12.2091 14 10H12ZM10 8C11.1046 8 12 8.89543 12 10H14C14 7.79086 12.2091 6 10 6V8ZM8 10C8 8.89543 8.89543 8 10 8V6C7.79086 6 6 7.79086 6 10H8ZM10 12C8.89543 12 8 11.1046 8 10H6C6 12.2091 7.79086 14 10 14V12Z"
      fill={SV.colors.interactive1}
    />
  </svg>
);

export const CrossIcon: React.FunctionComponent<{
  onClick?: any;
  style?: any;
}> = ({ onClick, style = {} }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ cursor: "pointer", ...style }}
    onClick={onClick}
  >
    <path
      d="M1 1L19 19M19 1L1 19"
      stroke={SV.colors.interactive1}
      // stroke-width="2"
      strokeLinecap="round"
    />
  </svg>
);

export const TriangleIcon: React.FunctionComponent<any> = ({ style }) => (
  <svg
    width="12"
    height="7"
    viewBox="0 0 12 7"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={style}
  >
    <path
      d="M5.29289 6.29289L0.707107 1.70711C0.0771419 1.07714 0.523308 0 1.41421 0H10.5858C11.4767 0 11.9229 1.07714 11.2929 1.70711L6.70711 6.29289C6.31658 6.68342 5.68342 6.68342 5.29289 6.29289Z"
      fill="#050925"
    />
  </svg>
);

export const BellIcon = () => (
  <svg
    width="26"
    height="26"
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ cursor: "pointer" }}
  >
    <path
      d="M7.66005 21.3205C8.61267 21.8705 9.8421 21.5411 10.3921 20.5884L6.92799 18.5884C6.37799 19.5411 6.70742 20.7705 7.66005 21.3205ZM16.2892 19.3743L19.0392 14.6112C20.5892 11.9265 20.0206 8.71146 17.8591 6.65524L18.2091 6.04902C18.6091 5.3562 18.3529 4.39999 17.66 3.99999C16.9672 3.59999 16.011 3.8562 15.611 4.54902L15.261 5.15524C12.3995 4.31146 9.33088 5.42652 7.78088 8.1112L5.03088 12.8743L2.29883 13.6064L1.79883 14.4724L16.5213 22.9724L17.0213 22.1064L16.2892 19.3743ZM14.0572 19.2404L6.26293 14.7404L9.51293 9.1112C10.7629 6.94614 13.495 6.21409 15.66 7.46409C17.8251 8.71409 18.5572 11.4461 17.3072 13.6112L14.0572 19.2404Z"
      fill={SV.colors.interactive1}
    />
  </svg>
);

export const HelpTextIcon = () => {
  return (
    <HelpText>
      <HelpTextQuestion> ?</HelpTextQuestion>
      <Tooltip>
        <span>The exam mode </span> allows you to feel like in a real exam, and
        test your abilities to the fullest. Questions will be automatically
        selected, you will not be shown the correct answers, comments, and time
        will be limited
        <br />
        <br />
        <span> * this feature is coming soon </span>
      </Tooltip>
    </HelpText>
  );
};

export const FacebookIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    width="32"
    height="32"
    viewBox="0 0 256 256"
  >
    <g
      fill="#ffffff"
      fillRule="nonzero"
      stroke="none"
      strokeWidth="1"
      strokeLinecap="butt"
      strokeLinejoin="miter"
      strokeMiterlimit="10"
      strokeDasharray=""
      strokeDashoffset="0"
      fontFamily="none"
      fontWeight="none"
      fontSize="none"
      textAnchor="none"
      style={{ mixBlendMode: "normal" }}
    >
      <g transform="scale(10.66667,10.66667)">
        <path d="M12,2c-5.5,0 -10,4.5 -10,10c0,5 3.7,9.2 8.5,9.9v-7.3h-1.6c-0.7,0 -1.3,-0.6 -1.3,-1.3c0,-0.7 0.6,-1.3 1.3,-1.3h1.6v-1.8c0,-2.9 1.4,-4.2 3.8,-4.2c0.4,0 0.7,0 0.9,0c0.6,0 1.1,0.6 1.1,1.2c0,0.7 -0.5,1.2 -1.2,1.2h-0.4c-1,0.1 -1.4,1.1 -1.4,2.2v1.4h1.9c0.6,0 1,0.5 1,1.1l-0.1,0.7c-0.1,0.5 -0.5,0.8 -1,0.8h-1.8v7.3c4.9,-0.6 8.7,-4.8 8.7,-9.9c0,-5.5 -4.5,-10 -10,-10z" />
      </g>
    </g>
  </svg>
);

export const InstagramIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    width="32"
    height="32"
    viewBox="0 0 256 256"
  >
    <g
      fill="#FFFFFF"
      fillRule="nonzero"
      stroke="none"
      strokeWidth="1"
      strokeLinecap="butt"
      strokeLinejoin="miter"
      strokeMiterlimit="10"
      strokeDasharray=""
      strokeDashoffset="0"
      fontFamily="none"
      fontWeight="none"
      fontSize="none"
      textAnchor="none"
      style={{ mixBlendMode: "normal" }}
    >
      <g transform="scale(10.66667,10.66667)">
        <path d="M8,3c-2.74952,0 -5,2.25048 -5,5v8c0,2.74952 2.25048,5 5,5h8c2.74952,0 5,-2.25048 5,-5v-8c0,-2.74952 -2.25048,-5 -5,-5zM8,5h8c1.66848,0 3,1.33152 3,3v8c0,1.66848 -1.33152,3 -3,3h-8c-1.66848,0 -3,-1.33152 -3,-3v-8c0,-1.66848 1.33152,-3 3,-3zM17,6c-0.55228,0 -1,0.44772 -1,1c0,0.55228 0.44772,1 1,1c0.55228,0 1,-0.44772 1,-1c0,-0.55228 -0.44772,-1 -1,-1zM12,7c-1.58333,0 -2.89811,0.62976 -3.74805,1.58594c-0.84994,0.95618 -1.25195,2.19184 -1.25195,3.41406c0,1.22222 0.40201,2.45788 1.25195,3.41406c0.84994,0.95618 2.16471,1.58594 3.74805,1.58594c1.58333,0 2.89811,-0.62976 3.74805,-1.58594c0.84994,-0.95618 1.25195,-2.19184 1.25195,-3.41406c0,-1.22222 -0.40201,-2.45788 -1.25195,-3.41406c-0.84994,-0.95618 -2.16471,-1.58594 -3.74805,-1.58594zM12,9c1.08333,0 1.76856,0.37024 2.25195,0.91406c0.48339,0.54382 0.74805,1.30816 0.74805,2.08594c0,0.77778 -0.26465,1.54212 -0.74805,2.08594c-0.48339,0.54382 -1.16862,0.91406 -2.25195,0.91406c-1.08333,0 -1.76856,-0.37024 -2.25195,-0.91406c-0.48339,-0.54382 -0.74805,-1.30816 -0.74805,-2.08594c0,-0.77778 0.26465,-1.54212 0.74805,-2.08594c0.48339,-0.54382 1.16862,-0.91406 2.25195,-0.91406z" />
      </g>
    </g>
  </svg>
);

export const YoutubeIcon = () => (
  <svg
    width="31"
    height="31"
    viewBox="0 0 31 31"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.54102 28H26.459C28.9629 28 31 25.9296 31 23.3846V8.61538C31 6.07043 28.9629 4 26.459 4H4.54102C2.03707 4 0 6.07043 0 8.61538V23.3846C0 25.9296 2.03707 28 4.54102 28ZM1.81641 8.61538C1.81641 7.08846 3.0387 5.84615 4.54102 5.84615H26.459C27.9613 5.84615 29.1836 7.08846 29.1836 8.61538V23.3846C29.1836 24.9115 27.9613 26.1538 26.459 26.1538H4.54102C3.0387 26.1538 1.81641 24.9115 1.81641 23.3846V8.61538Z"
      fill="#050925"
    />
    <path
      d="M11 9V21L22 14.9016L11 9ZM12.8283 12.0006L18.2825 14.9269L12.8283 17.9507V12.0006Z"
      fill="#050925"
    />
  </svg>
);

//@ts-ignore
const Tooltip = styled(DashboardBox)`
  position: absolute;
  width: 240px;
  height: 210px;
  visibility: hidden;
  top: -100px;
  left: -250px;
  font-weight: normal;
  font-size: 12px;
  line-height: 155.5%;
  padding: 20px;
  z-index: 60;
  border: 1px solid #dfdfdf;
  span {
    font-weight: bold;
  }
`;

const HelpTextQuestion = styled.div`
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  background: rgba(56, 96, 200, 0.5);
  width: 20px;
  height: 20px;
  border-radius: 50%;
`;

const HelpText = styled.div`
  position: relative;
  :hover {
    ${Tooltip} {
      visibility: visible;
    }
  }
`;
